import React from "react";
import { Link } from "react-router-dom";

function AboutOne() {
  return (
    <div
      className="about-area position-relative overflow-hidden space"
      id="about-sec"
    >
      <div className="container shape-mockup-wrap">
        <div className="row">
          <div className="col-xl-6">
            <div className="img-box1">
              <div className="img1">
                <img src="/assets/img/normal/about_1_1.jpg" alt="About" />
              </div>
              <div className="img2">
                <img src="/assets/img/normal/about_1_2.jpg" alt="About" />
              </div>
              <div className="img3">
                <img src="/assets/img/normal/about_1_3.jpg" alt="About" />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="ps-xl-4 ms-xl-2">
              <div className="title-area mb-20 pe-xl-5 me-xl-5">
                <span className="sub-title style1">
                  Smart Printing Starts Here
                </span>
                <h2
                  className="sec-title mb-20 pe-xl-5 me-xl-5"
                  style={{ fontSize: "28px", marginTop: "15px" }}
                >
                  Discover the Perfect Printer for Your Home or Business
                </h2>
                <p className="sec-text mb-30">
                  Finding the right printer shouldn’t be confusing or expensive.
                  Whether you need a reliable home printer, a high volume office
                  model or the latest wireless smart printer, we make it easy to
                  compare, choose and order with confidence. Every product in
                  our catalog is carefully selected from trusted brands and
                  backed by expert support, fast delivery and a smooth buying
                  experience.
                </p>
              </div>

              <div className="about-item-wrap">
                <div className="about-item">
                  <div className="about-item_img">
                    <img src="/assets/img/icon/map3.svg" alt="" />
                  </div>
                  <div className="about-item_centent">
                    <h5 className="box-title">Premium Quality Products</h5>
                    <p className="about-item_text">
                      We offer a curated selection of the best printer models
                      designed for durability, performance and long term value.
                    </p>
                  </div>
                </div>

                <div className="about-item">
                  <div className="about-item_img">
                    <img src="/assets/img/icon/guide.svg" alt="" />
                  </div>
                  <div className="about-item_centent">
                    <h5 className="box-title">Expert Customer Support</h5>
                    <p className="about-item_text">
                      Our knowledgeable team is here to help you choose the
                      right printer and provide after purchase assistance when
                      needed.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-35">
                <Link to="/contact" className="th-btn style3 th-icon">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Shapes stay unchanged */}
        <div
          className="shape-mockup shape1 d-none d-xl-block"
          style={{ top: "12%", left: "-16%" }}
        >
          <img src="/assets/img/shape/shape_1.png" alt="shape" />
        </div>
        <div
          className="shape-mockup shape2 d-none d-xl-block"
          style={{ top: "20%", left: "-16%" }}
        >
          <img src="/assets/img/shape/shape_2.png" alt="shape" />
        </div>
        <div
          className="shape-mockup shape3 d-none d-xl-block"
          style={{ top: "14%", left: "-10%" }}
        >
          <img src="/assets/img/shape/shape_3.png" alt="shape" />
        </div>
        <div
          className="shape-mockup about-shape movingX d-none d-xxl-block"
          style={{ bottom: "0%", right: "-11%" }}
        >
          <img src="/assets/img/normal/about-slide-img.png" alt="shape" />
        </div>
        <div
          className="shape-mockup about-rating d-none d-xxl-block"
          style={{ bottom: "50%", right: "-20%" }}
        >
          <i className="fa-sharp fa-solid fa-star" />
          <span>4.9k</span>
        </div>
        <div
          className="shape-mockup about-emoji d-none d-xxl-block"
          style={{ bottom: "25%", right: "5%" }}
        >
          <img src="/assets/img/icon/emoji.png" alt="" />
        </div>
      </div>
    </div>
  );
}

export default AboutOne;
